import React, { useMemo } from 'react';
import { noop } from 'lodash';
import SeriesRadarChart, {
  questionSetsFromDataMap,
} from 'js/components/Charts/SeriesRadarChart';
import { getSummaryMetrics } from 'js/utils/question-set';
import standardCohortKeys from 'js/utils/cohort-keys';

function CohortSeriesRadarChart({
  assessment,
  assessmentId,
  dataMap,
  legendFields = [],
  participantCohortMap,
  categoryLookups,
  categoryColorMap,
  legendHeading = 'Cohorts',
  breakoutName = null,
  isLoading = false,
  resetPinKey,
  pinnedCohort,
  activeCohort,
  onPinCohort = noop,
  onClearPinnedCohort = noop,
  onPeekCohort = noop,
  onClearPeekedCohort = noop,
}) {
  const questionSets = useMemo(
    () => questionSetsFromDataMap(dataMap, assessmentId),
    [dataMap, assessmentId]
  );

  const series = useMemo(
    () =>
      (legendFields ?? []).map((field) => {
        const fieldDataMap =
          field.key === standardCohortKeys.CUMULATIVE || !assessment
            ? dataMap
            : getSummaryMetrics([assessment], {
                filter: { cohorts: { [field.key]: true } },
                participantCohortsMap: participantCohortMap,
              });
        return {
          key: field.key,
          name: field.name,
          paletteIndex: field.paletteIndex,
          disabled: Boolean(field.disabled),
          questionSets: questionSetsFromDataMap(fieldDataMap, assessmentId),
        };
      }),
    [legendFields, assessment, dataMap, participantCohortMap, assessmentId]
  );

  return (
    <SeriesRadarChart
      questionSets={questionSets}
      series={series}
      categoryLookups={categoryLookups}
      categoryColorMap={categoryColorMap}
      legendHeading={legendHeading}
      legendCaption={breakoutName}
      isLoading={isLoading}
      resetPinKey={resetPinKey}
      pinnedKey={pinnedCohort}
      activeKey={activeCohort}
      onPin={onPinCohort}
      onClearPin={onClearPinnedCohort}
      onPeek={onPeekCohort}
      onClearPeek={onClearPeekedCohort}
      enableSeriesFilter
      dimInactive
    />
  );
}

export default CohortSeriesRadarChart;
